import { useState, useEffect } from 'react';
import axios from 'axios';

/**
 * Hook to fetch admin1 geometry for a view
 * @param {string} viewIso3 - ISO3 code of the view
 * @returns {Object} - { data, loading, error }
 */
export function useAdmin1Geometry(viewIso3, resolution = 0.005) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log("[useAdmin1Geometry] fetchGeometry called for:", viewIso3);
    const fetchGeometry = async () => {
      if (!viewIso3) {
        setData(null);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(`/api/fieldmaps/admin1-geometry/${viewIso3}`, {
          params: { resolution }
        });
        
        if (response.data.success) {
          setData(response.data.data);
        } else {
          setError(response.data.error || 'Failed to fetch admin1 geometry');
        }
      } catch (err) {
        setError(err.message || 'Failed to fetch admin1 geometry');
      } finally {
        setLoading(false);
      }
    };

    fetchGeometry();
  }, [viewIso3]);

  return { data, loading, error };
}
